import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/sai-logos.png';
import master from '../assets/master-card.png';
import visa from '../assets/visa.png';
import netbanking from '../assets/net-banking.png';
import upi from '../assets/upi.png';

const Footer = () => {
  return (
    <footer className="bg-white pt-8 pb-0 w-full">
      <div className="w-full lg:px-0 px-3">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12 max-w-[1420px] mx-auto">
          <div className="space-y-4">
            <img 
              src={logo} 
              alt="Logo" 
              className="w-44 md:w-32 mb-4" 
            />
            <p className="text-gray-600 text-sm leading-relaxed max-w-md">
              Sai Aqua Pets offers a wide range of pet products and services, including food, accessories, medicines, and toys for your lovely pets.
              We are committed to providing the best care for your pets with quality products and exceptional service.
            </p>
          </div>

          {/* Shopping Links Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Online Shopping</h3>
            <nav className="grid grid-cols-1 gap-2">
              {[
                'PET ACCESSORIES',
                'PET APPARELS',
                'PET COMBO',
                'PET FOOD',
                'PET GROOMING',
                'PET SUPPLIES'
              ].map((item) => (
                <a 
                  key={item}
                  href="#" 
                  className="text-gray-600 hover:text-blue-600 transition-colors duration-200 flex items-center group"
                >
                  <span className="transform group-hover:translate-x-2 transition-transform duration-200">
                    {item}
                  </span>
                </a>
              ))}
            </nav>
          </div>

          {/* Contact Section */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Contact Us</h3>
              <div className="space-y-3">
                <p className="flex items-start space-x-3 text-gray-600">
                  <FaMapMarkerAlt className="text-blue-600 mt-1 flex-shrink-0" />
                  <span className="flex-1">No: 10A, North Mada Street, Kolathur, Chennai-600009</span>
                </p>
                <p className="flex items-center space-x-3">
                  <FaPhone className="text-blue-600 flex-shrink-0" />
                  <a 
                    href="tel:+91 63838 89291" 
                    className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
                  >
                    +91 63838 89291
                  </a>
                </p>
                <p className="flex items-center space-x-3">
                  <FaEnvelope className="text-blue-600 flex-shrink-0" />
                  <a 
                    href="mailto:info@saiaquapets.com" 
                    className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
                  >
                    info@saiaquapets.com
                  </a>
                </p>
              </div>
            </div>

            {/* Social Media Section */}
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a 
                  href="#" 
                  className="text-blue-600 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
                  aria-label="Facebook"
                >
                  <FaFacebook size={26} />
                </a>
                <a 
                  href="#" 
                  className="text-blue-600 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
                  aria-label="Twitter"
                >
                  <FaTwitter size={26} />
                </a>
                <a 
                  href="https://www.instagram.com/sai_aqua_and_pets/" 
                  className="text-blue-600 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
                  aria-label="Instagram"
                >
                  <FaInstagram size={26} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright and Payment Methods Section */}
        <div className="mt-8 w-full">
          <div className="bg-blue-600 mt-6 py-4 w-full">
            <div className="max-w-[1440px] mx-auto px-4">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <p className="text-white text-sm text-center sm:text-left whitespace-nowrap">
                  &copy; 2024 Sai Aqua Pets. All rights reserved.
                </p>

                <div className="flex flex-wrap justify-center gap-4 items-center">
                  {[master, visa, netbanking, upi].map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt="Payment method"
                      className="h-8 w-auto object-contain bg-white rounded p-1"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;